import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import request, { NodeURL } from "../../api/api";

class Referenceform_Success extends Component {
    state = {
        logourl: '',
    };

    componentDidMount() {
        const subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : false;
        request({
            url: "/site/agencies",
            method: "POST",
        }).then((res) => {
            const filteredlist = res && res.response && res.response.result && res.response.result.filter((list) => list.domain.toString() === subdomain.toString());
            this.setState({ logourl: filteredlist && filteredlist[0] && filteredlist[0].company_logo });
        });
    }

    render() {
        let { logourl } = this.state;
        return (
            <div className="candidate-main">
                <Fragment>
                    <ToastContainer position="top-right" autoClose={2500} closeOnClick />
                    <div className="mar-top"></div>
                    <div className="card main-space">
                        <div className="container">
                            <div className="reference-main">
                                <div className="row ">
                                    <div className="col-12">
                                        <span className="ref-logos">
                                            <img src={logourl && logourl.length > 0 && String(logourl) !== String(undefined) ? `${NodeURL}/${logourl}` : ''} alt="" />
                                        </span>
                                        <h3 className="text-center font-box">Thank you for submitting the reference! </h3>
                                        <h2 className="text-center"><b> We appreciate your time. </b></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }
}

export default Referenceform_Success;
